export default __webpack_public_path__ + "static/media/Carrusel_Arrow_right.8d449dde.svg";